import { SetLog, TagLogs } from "../../../logs/set-log";
import { getIntegrationServiceAxios } from "./config-requests";
import { getApiStatusError, getApiStatusSuccess } from "./get-api-results";
import { getInfos } from "./get-infos";

export async function sendLeadIntegrationService(leadData, currentLead) {
  try {
    if (!currentLead?.attributes) {
      return getApiStatusError("lead_not_found", { leadData, currentLead });
    }
    const infos = await getInfos();
    const resultSaveLead = await getIntegrationServiceAxios(infos)
      .post(infos.integration_services_api_lead_route, {
        api_key: infos.integration_services_api_key,
        data: leadData,
        external_id: currentLead.attributes.external_id,
      })
      .then((result) => result.data);
    return getApiStatusSuccess("sended_lead", resultSaveLead);
  } catch (error) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Erro desconhecido";
    return getApiStatusError(errorMessage, { leadData, currentLead });
  }
}